// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__3K4re","checked":"Checkbox_checked__Fz7b6","flex":"Checkbox_flex__2oAma","label":"Checkbox_label__29G_q","icon":"Checkbox_icon__1qhhC"};